<template>
  <div>
    <div class="page_center">
      <div style="height:71px; width:100%"></div>
      <div class="banner-top-wrapper">
        <image-component
          :is_jpg="isJpg"
          :name="bannerName"
          path=""
        ></image-component>
        <div class="banner-title">
          <div>
            <span class="font22">부모님의 외로움을 달래 주는</span>
            <br />
            <span class="font48 fontExtraBold">AI인형 </span>
            <span class="font48 fontExtraBold orange">'효돌이'</span>
          </div>
          <div class="title-icon-wrapper">
            <image-component
              :is_jpg="false"
              name="ic_hydol"
              path=""
            ></image-component>
          </div>
          <div>
            <span class="font22">여가생활 증진과 인지력 향상의</span>
            <br />
            <span class="font48 fontExtraBold">스마트 테이블</span>
            <br />
            <span class="font48 fontExtraBold deepOrange">'해피테이블'</span>
          </div>
        </div>
      </div>
      <div class="info-banner-wrapper">
        <div class="page_padding">
          <div class="info-title">
            <span>효돌과 해피테이블의 콜라보레이션!</span>
            <br />
            <span class="underline">해피테이블을 태블릿으로 만나보세요.</span>
          </div>
          <div class="info-banner-img">
            <image-component
              class=""
              :is_jpg="false"
              name="hydol_img01"
              path=""
            ></image-component>
          </div>
        </div>
      </div>
      <div class="" style="background-color: #F6EFE8">
        <div class="page_padding content info paddingT">
          <p class="fontExtraBold">효돌 태블릿의 기능</p>
          <!-- <span class="title text333 paddingBottom18"></span> -->
        </div>
        <div class="cognitive page_padding">
          <div
            class="info-block"
            v-for="(item, index) in cognitiveContents"
            :key="index"
          >
            <div>
              <image-component
                :is_jpg="false"
                path=""
                :name="item.path"
              ></image-component>
            </div>
            <div class="cognitive-content-wrapper">
              <div class="sub-title text-left font34">
                <span class="fontExtraBold">{{ item.headline }}</span>
              </div>
              <div class="verticalSpacer-half"></div>
              <div class="text-left">
                <div v-html="item.content" class="sub-content"></div>
                <!-- <span class="fontS word_break sub-content">{{
                  item.content
                }}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="business-content page_padding">
        <div class="page_padding content info paddingT">
          <p class="fontExtraBold">구매문의</p>
          <p class="sub">
            구매문의는 해피테이블 카카오 채널로 채팅 부탁드립니다.
          </p>
          <a
            class="kakao-link"
            href="http://pf.kakao.com/_xjYRxab"
            target="_blank"
          >
            <div class="kakao" style="display:flex">
              <div class="kakao-img-wrapper">
                <img
                  src="@/assets/source/images/m_ic_sns_kakao.svg"
                  alt="go to kakao"
                />
              </div>
              <p class="title">카카오 채널 문의</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imageComponent from "../components/imageComponent.vue";
export default {
  components: {imageComponent},
  data() {
    return {
      cognitiveContents: [
        {
          headline: "기능 1",
          content:
            "태블릿에서도 <span class='orange'>해피테이블</span>을 즐겨요!",
          path: "hydol_img02",
        },
        {
          headline: "기능 2",
          content:
            "효돌 챗봇을 통해 <span class='orange'>노래도 듣고 유튜브도 감상</span>하세요!",
          path: "hydol_img03",
        },
        {
          headline: "기능 3",
          content:
            "태블릿을 통해 효돌 학습지가 가능합니다. <span class='orange'>치매 예방 수업에 활용</span>하세요!",
          path: "hydol_img04",
        },
      ],
      isJpg: false,
      bannerName: "hydol_top",
    };
  },
  methods: {
    checkBrowserWidth() {
      // this.isMobile = window.innerWidth <= 1200;
      // if (window.innerWidth <= 650) {
      //   this.bannerName = "m_hydol_top480";
      //   this.isJpg = true;
      // } else if (window.innerWidth <= 1200) {
      //   this.bannerName = "m_hydol_top";
      //   this.isJpg = false;
      // } else {
      //   this.bannerName = "hydol_top";
      //   this.isJpg = true;
      // }
    },
  },
  created() {
    this.checkBrowserWidth();
    window.addEventListener("resize", this.checkBrowserWidth);
  },
};
</script>
<style>
.orange {
  color: #ef7d52;
}
</style>
<style scoped>
.banner-top-wrapper {
  position: relative;
}
.banner-top-wrapper >>> img {
  display: block;
}
.banner-title {
  position: absolute;
  top: 6rem;
  left: 50%;
  transform: translate(-50%, 0%);

  width: 70%;
  max-width: 730px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.title-icon-wrapper {
  width: 40px;
  height: 40px;
}
.title-icon-wrapper >>> img {
  display: block;
}
.banner-title .font22 {
  font-size: 22px;
}
.banner-title .font48 {
  font-size: 48px;
  line-height: 4rem;
}
.orange {
  color: #ef7d52;
}
.deepOrange {
  color: #ff5230;
}
.info-banner-wrapper {
  background-color: #ef7d52;
  padding: 90px 0;
}
.info-title {
  font-size: 34px;
  line-height: 3rem;
  color: #ffffff;
  word-break: keep-all;
}
.underline {
  text-decoration-line: underline;
  text-underline-offset: 10px;
}
.info-banner-img {
  max-width: 870px;
  width: 70%;
  margin: 2rem auto;
}

.content-wrapper {
  padding: 1rem 1rem 2rem 1rem;
}
.cognitive {
  padding: 3rem 0;
}
.cognitive .info-block {
  display: flex;
  align-items: center;
  padding: 2rem;
  box-shadow: 0px 3px 6px #5e331529;
  margin-bottom: 3rem;
  background-color: #ffff;
}
.marginB {
  margin-bottom: 100px;
}
.sub-title {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ef7d52;
  border-radius: 27px;
  padding: 0.7rem 2rem;
  max-width: 56px;
}
.sub-title span {
  /* background-color: #ef7d52;
  border-radius: 27px;
  padding: 1rem 2rem; */
  font-size: 20px;
  color: white;
}
.sub-content {
  font-size: 30px;
  font-weight: bold;
  line-height: 3rem;
}
.business-content .sub {
  font-size: 18px;
  padding: 2.5rem 0;
  word-break: keep-all;
}
.kakao-img-wrapper {
  width: 54px;
  height: 54px;
}
.kakao-img-wrapper img {
  display: block;
  width: 100%;
}
.kakao {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 524px;
  border: 2px solid #ef7d52;
  border-radius: 62px;
  margin: 0 auto;
  padding: 2rem 0;
}
.kakao .title {
  color: #d65422;
  font-size: 34px;
  margin-left: 2rem;
}
.kakao-link {
  text-decoration: none;
}

.mobile {
  display: none;
}
.background-page {
  background-color: #f2f4f6;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  /* height: 480px; */
  /* height: 28vw; */
}
.cognitive {
  padding-bottom: 3rem !important;
}
.cognitive .info-block {
  display: flex;
  align-items: center;
  padding: 2rem;
  box-shadow: 0px 3px 6px #5e331529;
  margin-bottom: 3rem;
  background-color: #ffff;
}
.cognitive-content-wrapper {
  padding: 1rem 2rem;
  width: 70%;
}
.cognitive-img-container {
  display: flex;
  justify-content: space-between;
}
.cognitive-img-wrapper {
  width: 48%;
}

.cognitive-item-flex {
  display: flex;
  justify-content: center;
}
.cognitive-item {
  width: 25%;
}
.cognitive-item >>> img {
  display: block;
}
.icon-wrapper {
  width: 30%;
  margin: 0 auto;
  background-color: white;
  border-radius: 50%;
  padding: 2rem;
}
.content-wrapper {
  padding: 1rem 1rem 2rem 1rem;
}
.content-header {
  margin-bottom: 1rem;
}
.cognitive-info-wrapper {
  background-color: #e7e7e7;
  padding: 1rem 0;
}
.cognitive-info-wrapper .content {
  color: #dc375d;
}
.content.info {
  padding: 5rem 0 !important;
}
.content p {
  font-size: 30px;
}
.marginB {
  margin-bottom: 100px;
}
</style>
